import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/aceiteCancelamento/';

class AceiteCancelamentoService{
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type':'application/json',
        'authorization':'Bearer ' + (data ? data.token:'')
      };
    });
  }

  findNotasAceite(documento, idNota){
    return axios.get(API_URL + 'notasAceite?documento='+documento+'&idNota='+idNota, {headers: this.headers});
  }

  findNotasNegadas(documento, idNota){
    return axios.get(API_URL + 'notasNegadas?documento='+documento+'&idNota='+idNota, {headers: this.headers});
  }

  saveStatusAceite(aceite){
    return axios.post(API_URL, JSON.stringify(aceite), {headers: this.headers});
  }

}

export default new AceiteCancelamentoService();

